const moment = require('moment')

// Period bounds are either 'YYYY-MM-DD' strings (UI / jobs) or Date/moment values
// (dateRange fields, e.g. Report.period). Dates are read as their local calendar day.
const toDay = value => typeof value === 'string'
    ? moment.utc(value.trim(), 'YYYY-MM-DD')
    : moment.utc(moment(value).format('YYYY-MM-DD'), 'YYYY-MM-DD')

// Alert date-window filter, matching AlertConfiguration.getAlertQueryFilter
// ("consulter les alertes"): an alert is in range when its period-end bound
// (date.lt) is in (start, end + 1 day].  period = [start, end], end inclusive.
const buildAlertPeriodQuery = ([start, end]) => ({
    'date.lt': {
        $gt: toDay(start).toDate(),
        $lte: toDay(end).add(1, 'days').toDate()
    }
})

module.exports = { buildAlertPeriodQuery }